import api from "API";

import * as Analytics from "./payloads";

export const bespokeDashboardsEndpoint = `/organisations/:org/explo-dashboards`;
export const standardDashboardsEndpoint = `/organisations/:org/standard-explo-dashboards/`;

const extendedEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    bespokeExploDashboards: builder.query<
      Analytics.GetBespokeDashboards,
      Analytics.OrganisationScopedArgs
    >({
      query: ({ organisationId }) => ({
        url: bespokeDashboardsEndpoint.replace(":org", organisationId),
      }),
    }),
    standardExploDashboards: builder.query<
      Analytics.GetStandardDashboards,
      Analytics.OrganisationScopedArgs
    >({
      query: ({ organisationId }) => ({
        url: standardDashboardsEndpoint.replace(":org", organisationId),
      }),
    }),
    exploJwtToken: builder.mutation<
      Analytics.JwtTokenResponse,
      Analytics.JwtTokenParams
    >({
      query: ({ dashboardId, ...entityPk }) => ({
        url: standardDashboardsEndpoint + `${dashboardId}/` + "token",
        method: "POST",
        body: entityPk,
      }),
    }),
  }),
});

export const {
  useBespokeExploDashboardsQuery,
  useStandardExploDashboardsQuery,
  useExploJwtTokenMutation,
} = extendedEndpoints;
